export class Requestor {
    constructor(private _rqCode: string, private _rqValue: string) {

    }

    get rqCode(): string {
        return this._rqCode;
    }

    get rqValue(): string {
        return this._rqValue;
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestList/models/requestor.ts
 **/